<div class="wrapper">
  <div class="header">
    <p style="vertical-align: center; text-align: center">
      <img src="../../../assets/lfw-logo-default.png" title="LiveFORMS-Web" alt="LiveFORMS.web Logo" /> <br />
      <label>{{ longVersion }}</label>
    </p>
  </div>
  <div class="content">
    @if (loginAllowed()) {
      <button
        mat-raised-button
        (click)="login($event)"
        matTooltip="{{ showToolTip() ? ('DIALOGS.OPENIDLOGIN' | translate) : '' }}">
        <mat-icon class="button-icon-person">person</mat-icon>{{ 'DIALOGS.OPENIDLOGIN' | translate }}
      </button>
    }
    @if (hasMessage()) {
      <mat-card class="message">
        <mat-card-header>
          <div class="message-header">
            <mat-icon>information</mat-icon>
            <div class="message-header-text">{{ messageHeader() }}</div>
          </div>
        </mat-card-header>
        <mat-card-content class="message-text">{{ messageText() }}</mat-card-content>
      </mat-card>
    }
  </div>

  <div class="footer">
    @if (showImprint()) {
      <div>
        <a href="{{ urlImprint() }}">{{ textImprint() }} </a>
      </div>
    }
    @if (showPrivacy()) {
      <div>
        <a href="{{ urlPrivacy() }}">{{ textPrivacy() }} </a>
      </div>
    }
    @if (showServerInfo()) {
      <div>{{ serverInfo() }}</div>
    }
  </div>
</div>
